/* eslint-disable max-len */
import React from 'react';

import LocalisedMessage from 'components/Common/LocalisedMessage';

const w8ben = {
  FormName: 'W-8BEN',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN</strong></span>
    </div>
    <div className="bottom-pad"><LocalisedMessage id="w8ben.formChoiceModl.formChoiceContent.formRevision" /></div>
    <div className="bottom-pad"><LocalisedMessage id="w8ben.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8ben.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <LocalisedMessage id="certification.electronicSignatureConsent" />
    <LocalisedMessage id="w8ben.certification.electronicSignatureConsent" />
  </div>
};
const w8ben2021 = {
  FormName: 'W-8BEN',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN</strong></span>
    </div>
    <div className="bottom-pad"><LocalisedMessage id="w8ben2021.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div className="bottom-pad"><LocalisedMessage id="w8ben.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8ben2021.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <LocalisedMessage id="certification.electronicSignatureConsent" />
    <LocalisedMessage id="w8ben2021.certification.electronicSignatureConsent" />
  </div>
};
const w8bene2017 = {
  FormName: 'W-8BEN-E',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN-E</strong></span>
    </div>
    <div className="bottom-pad"><LocalisedMessage id="w8bene2017.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div className="bottom-pad"><LocalisedMessage id="w8bene.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8bene2017.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <LocalisedMessage id="certification.electronicSignatureConsent" />
    <LocalisedMessage id="w8bene2017.certification.electronicSignatureConsent" />
  </div>
};
const w8bene2021 = {
  FormName: 'W-8BEN-E',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN-E</strong></span>
    </div>
    <div className="bottom-pad"><LocalisedMessage id="w8bene2017.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div className="bottom-pad"><LocalisedMessage id="w8bene.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8bene2021.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <LocalisedMessage id="certification.electronicSignatureConsent" />
    <LocalisedMessage id="w8bene2021.certification.electronicSignatureConsent" />
  </div>
};
function w92018(subjectToBackupWithholding) {
  return {
    FormName: 'W-9',
    FormChoiceTitle: <div className="text-center">
      <div>
        Form <br />
        <span style={ { fontSize: '1rem' } }><strong>W-9</strong></span>
      </div>
      <div><LocalisedMessage id="w92018.formChoiceModal.formChoiceContent.formRevision" /></div>
      <div><LocalisedMessage id="w9.formChoiceModal.formChoiceContent.longFormName" /></div>
    </div>,
    FormChoiceContent: <div className="content">
      <LocalisedMessage id="w9.formChoiceModal.formChoiceContent" />
    </div>,
    CertificationContent: <div className="content">
      <LocalisedMessage id="certification.electronicSignatureConsent.title" />
      <LocalisedMessage id="certification.electronicSignatureConsent" />
      <LocalisedMessage id="w9.certification.electronicSignatureConsent.intro" />
      <ol>
        <li><LocalisedMessage id="w9.certification.electronicSignatureConsent.1" /></li>
        <li>{ subjectToBackupWithholding ? <s><LocalisedMessage id="w9.certification.electronicSignatureConsent.2" /></s> : <LocalisedMessage id="w9.certification.electronicSignatureConsent.2" /> }</li>
        <li><LocalisedMessage id="w9.certification.electronicSignatureConsent.3" /></li>
        <li><LocalisedMessage id="w9.certification.electronicSignatureConsent.4" /></li>
      </ol>
      <LocalisedMessage id="w9.certification.electronicSignatureConsent.instructions" />
    </div>
  };
}
function w92024(subjectToBackupWithholding) {
  return {
    FormChoiceTitle: <div className="text-center">
      <div>
        Form <br />
        <span style={ { fontSize: '1rem' } }><strong>W-9</strong></span>
      </div>
      <div><LocalisedMessage id="w92024.formChoiceModal.formChoiceContent.formRevision" /></div>
      <div><LocalisedMessage id="w9.formChoiceModal.formChoiceContent.longFormName" /></div>
    </div>,
    FormChoiceContent: <div className="content">
      <LocalisedMessage id="w9.formChoiceModal.formChoiceContent" />
    </div>,
    CertificationContent: <div className="content">
      <LocalisedMessage id="certification.electronicSignatureConsent.title" />
      <LocalisedMessage id="certification.electronicSignatureConsent" />
      <LocalisedMessage id="w9.certification.electronicSignatureConsent.intro" />
      <ol>
        <li><LocalisedMessage id="w9.certification.electronicSignatureConsent.1" /></li>
        <li>{ subjectToBackupWithholding ? <s><LocalisedMessage id="w9.certification.electronicSignatureConsent.2" /></s> : <LocalisedMessage id="w9.certification.electronicSignatureConsent.2" /> }</li>
        <li><LocalisedMessage id="w9.certification.electronicSignatureConsent.3" /></li>
        <li><LocalisedMessage id="w9.certification.electronicSignatureConsent.4" /></li>
      </ol>
      <LocalisedMessage id="w9.certification.electronicSignatureConsent.instructions" />
    </div>
  };
}
const w8imy2017 = {
  FormName: 'W-8IMY',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8IMY</strong></span>
    </div>
    <div className="bottom-pad"><LocalisedMessage id="w8imy2017.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div className="bottom-pad"><LocalisedMessage id="w8imy.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8imy.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <span><LocalisedMessage id="certification.electronicSignatureConsent" /></span>
    <LocalisedMessage id="w8imy.certification.electronicSignatureConsent.intro" />
  </div>
};
const w8imy2021 = {
  FormName: 'W-8IMY',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8IMY</strong></span>
    </div>
    <div className="bottom-pad"><LocalisedMessage id="w8imy2021.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div className="bottom-pad"><LocalisedMessage id="w8imy.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8imy.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <span><LocalisedMessage id="certification.electronicSignatureConsent" /></span>
    <LocalisedMessage id="w8imy.certification.electronicSignatureConsent.intro" />
  </div>
};
const w8eci = {
  FormName: 'W-8ECI',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8ECI</strong></span>
    </div>
    <div><LocalisedMessage id="w8eci.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div><LocalisedMessage id="w8eci.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8eci.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <span><LocalisedMessage id="certification.electronicSignatureConsent" /></span>
    <LocalisedMessage id="w8eci.certification.electronicSignatureConsent.intro" />
  </div>
};
const w8eci2021 = {
  FormName: 'W-8ECI',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8ECI</strong></span>
    </div>
    <div><LocalisedMessage id="w8eci2021.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div><LocalisedMessage id="w8eci.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8eci.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <span><LocalisedMessage id="certification.electronicSignatureConsent" /></span>
    <LocalisedMessage id="w8eci.certification.electronicSignatureConsent.intro" />
  </div>
};
const w8exp = {
  FormName: 'W-8EXP',
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8EXP</strong></span>
    </div>
    <div><LocalisedMessage id="w8exp.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div><LocalisedMessage id="w8exp.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8exp.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <span><LocalisedMessage id="certification.electronicSignatureConsent" /></span>
    <LocalisedMessage id="w8exp.certification.electronicSignatureConsent.intro" />
  </div>
};
const w8exp2023 = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8EXP</strong></span>
    </div>
    <div><LocalisedMessage id="w8exp2023.formChoiceModal.formChoiceContent.formRevision" /></div>
    <div><LocalisedMessage id="w8exp.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content">
    <LocalisedMessage id="w8exp2023.formChoiceModal.formChoiceContent" />
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <span><LocalisedMessage id="certification.electronicSignatureConsent" /></span>
    <LocalisedMessage id="w8exp.certification.electronicSignatureConsent.intro" />
  </div>
};
const crsi = {
  FormName: 'CRS-I',
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-I</strong></span>
    </div>
    <div><LocalisedMessage id="crsi.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="crsi.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="crsi.certification.electronicSignatureConsent" /></div>
};
const crsi2024 = {
  FormName: 'CRS-I',
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-I</strong></span>
    </div>
    <div><LocalisedMessage id="crsi.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="crsi.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="crsi.certification.electronicSignatureConsent" /></div>
};
const crse = {
  FormName: 'CRS-E',
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-E</strong></span>
    </div>
    <div><LocalisedMessage id="crse.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="crse.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="crse.certification.electronicSignatureConsent" /></div>
};
const crscp = {
  FormName: 'CRS-CP',
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-CP</strong></span>
    </div>
    <div><LocalisedMessage id="crscp.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="crscp.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="crscp.certification.electronicSignatureConsent" /></div>
};
const crsiw8ben = {
  FormName: 'CRS-I/W-8BEN',
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-I & W-8BEN</strong></span>
    </div>
    <div className="bottom-pad"><LocalisedMessage id="crsiw8ben.formChoiceModal.formChoiceContent.longCrsFormName" /></div>
    <div className="bottom-pad"><LocalisedMessage id="crsiw8ben.formChoiceModal.formChoiceContent.longWFormName" /></div>
  </div>,
  CertificationContent: <div className="content">
    <LocalisedMessage id="certification.electronicSignatureConsent.title" />
    <LocalisedMessage id="certification.electronicSignatureConsent" />
    <LocalisedMessage id="crsiw8ben.certification.electronicSignatureConsent" />
  </div>
};
const fatcacrse = {
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>FATCA/CRS-E</strong></span>
    </div>
    <div><LocalisedMessage id="fatcacrse.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="fatcacrse.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="fatcacrse.certification.electronicSignatureConsent" /></div>
};
const fatcacrsi = {
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>FATCA/CRS-I</strong></span>
    </div>
    <div><LocalisedMessage id="fatcacrsi.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="fatcacrsi.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="fatcacrsi.certification.electronicSignatureConsent" /></div>
};
const rc518 = {
  FormName: 'RC518',
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>RC518</strong></span>
    </div>
    <div><LocalisedMessage id="rc518.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="rc518.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="rc518.certification.electronicSignatureConsent" /></div>
};
const rc519 = {
  FormName: 'RC519',
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>RC519</strong></span>
    </div>
    <div><LocalisedMessage id="rc519.formChoiceModal.formChoiceContent.longFormName" /></div>
  </div>,
  FormChoiceContent: <div className="content"><LocalisedMessage id="rc519.formChoiceModal.formChoiceContent" /></div>,
  CertificationContent: <div className="content"><LocalisedMessage id="rc519.certification.electronicSignatureConsent" /></div>
};

const ModalInstructions = (formType, subjectToBackupWithholding) => {
  switch (formType) {
    case 'w9_2018':
      return w92018(subjectToBackupWithholding);
    case 'w9_2024':
      return w92024(subjectToBackupWithholding);
    case 'w8ben':
      return w8ben;
    case 'w8ben_2021':
      return w8ben2021;
    case 'w8bene_2017':
      return w8bene2017;
    case 'w8bene_2021':
      return w8bene2021;
    case 'w8eci':
      return w8eci;
    case 'w8eci_2021':
      return w8eci2021;
    case 'w8exp':
      return w8exp;
    case 'w8exp_2023':
      return w8exp2023;
    case 'w8imy_2017':
      return w8imy2017;
    case 'w8imy_2021':
      return w8imy2021;
    case 'crsi':
      return crsi;
    case 'crsi_2024':
      return crsi2024;
    case 'crse':
      return crse;
    case 'crscp':
      return crscp;
    case 'crsiw8ben':
      return crsiw8ben;
    case 'fatca_crse_2023':
      return fatcacrse;
    case 'fatca_crsi_2023':
      return fatcacrsi;
    case 'rc518':
    case 'rc518_2024':
    case 'rc518_2025':
      return rc518;
    case 'rc519':
    case 'rc519_2024':
    case 'rc519_2025':
      return rc519;
    default:
      return null;
  }
};

export default ModalInstructions;
